import { get } from 'lodash';
import { createConsts, createActions } from '../../utils/redux';

export const consts = createConsts(
  'community',
  'currentCommunityScrollStatus',
  'SET_SCROLL',
  'RESET',
  'ADD_TEMPORARY_POST_LIST',
);
export const actions = createActions(consts);

const initialState = {
  scrolled: false,
  temporaryPostList: [],
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case consts.SET_SCROLL:
      return {
        ...state,
        scrolled: payload.scrolled,
      };
    case consts.RESET:
      return initialState;
    case consts.ADD_TEMPORARY_POST_LIST: {
      const prevList = get(state, 'temporaryPostList');
      return {
        ...state,
        temporaryPostList: [...payload, ...prevList],
      };
    }
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/communities/currentCommunityScrollStatus.js